// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"591":"5378890c","664":"0f228bbb"}[chunkId] + ".chunk.css";
};